export enum Mood {
    GREAT = "Great",
    GOOD = "Good",
    OK = "Ok",
    NOT_SO_GOOD = "Not Good",
    BAD = "Bad",
    UNKNOWN = "N/A"
}